import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ColorService } from '../../services/color.service';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-template-theme-color',
  templateUrl: './template-theme-color.component.html',
  styleUrl: './template-theme-color.component.scss',
})
export class TemplateThemeColorComponent implements OnInit {
  colors: any;

  constructor(
    private colorService: ColorService,
    private cdr: ChangeDetectorRef,
    private themeService: ThemeService,
  ) { }

  ngOnInit(): void {
    this.colorService.getColorSets().subscribe((data) => {
      this.colors = { ...data.colors };
    });
  }
  getObjectKeys(set: any) {
    if (!set) {
      return [];
    }
    const keys = Object.keys(set);
    return keys;
  }

  applyTheme(theme: any) {
    this.themeService.applyThemeByName(theme);
    this.cdr.detectChanges();
    90;
  }
}
